const dlStatus = (state, valid = true) => {
    const stateOptions = {
        "Michigan": [
            "Select from the following...",
            ...(!valid ? [] : ["Valid"]),
            "Revoked",
            "Suspended",
            ...(!valid ? ["Expired"] : []),
            ...(!valid ? ["Surrendered"] : []),
            "Other"
        ],
        "New Jersey": [
            "Select from the following...",
            "Valid",
            "Valid Other State License",
            "Valid Foreign License",
            "International License",
            "Suspended",
            "Revoked",
            "Permit",
            "Expired",
            "Identification Only",
            "ID Only"
        ],
        "Pennsylvania": [
            "Select from the following...",
            "Valid Pennsylvania License",
            "Valid Other State License",
            "Valid Foreign License",
            "International License",
            "Suspended",
            "ID Only",
            "Revoked",
            "Permit",
            "Expired",
            "Identification Only"
        ]
    };
    return stateOptions[state]
}

export default dlStatus